import { CSSProperties } from 'react';

/**
 * CSS custom properties for the style prop: the runtime values of a CSS module (README, CSS),
 * e.g. style={cssVars({ '--accent': color, '--share': `${pct}%` })}.
 */
export const cssVars = (vars: Record<string, string | number | undefined>): CSSProperties => vars as CSSProperties;
